import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const Inquiry = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState('');
  // Image upload state
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]);
  const [isCompressingImages, setIsCompressingImages] = useState(false);

  const handleImageSelect = async (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/') && !file.type.startsWith('video/'));
    
    if (imageFiles.length === 0) {
      alert('画像ファイルを選択してください（動画ファイルは除く）');
      return;
    }

    if (selectedImages.length + imageFiles.length > 10) {
      alert('画像は最大10枚まで選択できます');
      return;
    }

    setIsCompressingImages(true);
    try {
      const compressedImages = await compressImages(imageFiles);
      setSelectedImages(prev => [...prev, ...compressedImages]);
      setImagePreviewUrls(prev => [...prev, ...compressedImages]);
    } catch (error) {
      console.error('Error compressing images:', error);
      alert('画像の圧縮に失敗しました');
    } finally {
      setIsCompressingImages(false);
    }
  };

  const removeImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviewUrls(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear any previous notifications
    setNotification('');
    
    

    setLoading(true);
    try {
      // Validate title and message
      if (!title.trim()) {
        setNotification('エラー : タイトルを入力してください');
        setLoading(false);
        return;
      }
      
      if (!message.trim() && selectedImages.length === 0) {
        setNotification('エラー : メッセージまたは画像を入力してください');
        setLoading(false);
        return;
      }
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/api/inquiry`, {
        title: title.trim(),
        message: message.trim(),
        images: selectedImages
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setNotification('お問い合わせが正常に送信されました！');
      setTitle('');
      setMessage('');
      setSelectedImages([]);
      setImagePreviewUrls([]);
      
      // Clear notification after 3 seconds
      setTimeout(() => setNotification(''), 3000);
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      setNotification('エラーが発生しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '20px', color: '#333' }}>お問い合わせ</h2>
      
      {notification && (
        <div style={{
          padding: '10px',
          marginBottom: '20px',
          backgroundColor: notification.includes('エラー') ? '#f8d7da' : '#d4edda',
          color: notification.includes('エラー') ? '#721c24' : '#155724',
          borderRadius: '5px',
          border: `1px solid ${notification.includes('エラー') ? '#f5c6cb' : '#c3e6cb'}`
        }}>
          {notification}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ maxWidth: '600px' }}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
            タイトル *
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              fontSize: '14px'
            }}
            placeholder="お問い合わせのタイトルを入力してください"
            maxLength={100}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
            メッセージ *
          </label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{
              width: '100%',
              minHeight: '150px',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              fontSize: '14px',
              resize: 'vertical'
            }}
            placeholder="お問い合わせの内容を入力してください"
            maxLength={1000}
          />
        </div>

        {/* Image Upload Section */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
            画像を添付（最大10枚、動画ファイルは除く）
          </label>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '10px' }}>
            {/* File selection button */}
            <label
              style={{
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: (isCompressingImages || selectedImages.length >= 10) ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                display: 'inline-block',
                opacity: (isCompressingImages || selectedImages.length >= 10) ? 0.6 : 1
              }}
            >
              📷 画像を選択
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageSelect}
                disabled={isCompressingImages || selectedImages.length >= 10}
                style={{ display: 'none' }}
              />
            </label>
            {/* Camera button for mobile */}
            <label
              style={{
                backgroundColor: '#27ae60',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: (isCompressingImages || selectedImages.length >= 10) ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                display: 'inline-block',
                opacity: (isCompressingImages || selectedImages.length >= 10) ? 0.6 : 1
              }}
            >
              📸 カメラで撮影
              <input
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleImageSelect}
                disabled={isCompressingImages || selectedImages.length >= 10}
                style={{ display: 'none' }}
              />
            </label>
          </div>
          {isCompressingImages && (
            <div style={{ color: '#666', fontSize: '12px', marginBottom: '10px' }}>
              画像を圧縮中...
            </div>
          )}
          {imagePreviewUrls.length > 0 && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
              gap: '10px',
              marginTop: '10px'
            }}>
              {imagePreviewUrls.map((url, index) => (
                <div key={index} style={{ position: 'relative' }}>
                  <img
                    src={url}
                    alt={`Preview ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '5px',
                      border: '1px solid #ddd'
                    }}
                  />
                  <button
                    onClick={() => removeImage(index)}
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      backgroundColor: '#e74c3c',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <button
          type="submit"
          disabled={loading || (!message.trim() && selectedImages.length === 0)}
          style={{
            backgroundColor: (loading || (!message.trim() && selectedImages.length === 0)) ? '#ccc' : '#007bff',
            color: 'white',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: (loading || (!message.trim() && selectedImages.length === 0)) ? 'not-allowed' : 'pointer',
            width: '100%'
          }}
        >
          {loading ? '送信中...' : '送信'}
        </button>
      </form>

      <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
        <h4 style={{ marginBottom: '10px', color: '#333' }}>📝 入力のヒント</h4>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#666' }}>
          <li>タイトルは簡潔に、内容を表すものにしてください</li>
          <li>メッセージには具体的な内容を記載してください</li>
          <li>絵文字も使用できます 😊</li>
          <li>管理者からの返信は「お問い合わせ履歴」で確認できます</li>
        </ul>
      </div>
    </div>
  );
};

export default Inquiry; 